import type { CometDSingleton } from '$lib/services/cometd/cometd.js';
import { getSessionEventConverters } from './eventConverters/index';
import { CHANNELS } from '../../cometd/cometd.constants';
import type { TEvent } from '../../cometd/cometd.types';
import { spineBus } from '../MessageBus';
import type { TEventConverterPayloads } from './eventConverters/eventConverter.types';
import { cond } from 'lodash-es';
import type { TPlayerData } from '../../lisService/types';
import type { TCond } from '$src/lib/common';

const subscriptionHandler = (event: TEvent) => {
    const conditions: TCond<TEvent, TEventConverterPayloads>[] = [...getSessionEventConverters()];

    const getPayload = cond<TEvent, TEventConverterPayloads>(conditions);
    const payload = getPayload(event);

    if (!payload) return;
    spineBus.publish('external', payload);
};

export const subscribeToCometDSessionChannelEvents = (
    cometd: CometDSingleton | undefined,
    playerData: TPlayerData | undefined,
    sessionId: string | undefined,
    unsubscribe: VoidFunction = () => {}
): VoidFunction => {
    if (!cometd || !playerData || !sessionId) {
        return unsubscribe;
    } else {
        const sessionChannel = `${CHANNELS.SESSION}/${sessionId}/ended`; // Related FRS code: https://github.com/Casumo/frontend-react-stack/blob/master/src/models/cometd/cometd.actions.ts#L48
        const sessionHandlePromise = cometd.subscribe(sessionChannel, subscriptionHandler, {
            sessionId
        });
        return () => sessionHandlePromise.then((playerHandle) => cometd.unsubscribe(playerHandle));
    }
};
